import React, { useEffect, useState } from 'react';
import Chart from "react-apexcharts";
import { Loader } from '../../components';

function ChartTransaction({ transactionHistory, loading }) {
  const [category, setCategory] = useState()
  const [series, setSeries] = useState([])


  let newDataTrans = [];
  let days = [];
  Object.keys(transactionHistory).map((key) => {
    newDataTrans.push({
      name: key,
      data: transactionHistory[key].relative,
      day: transactionHistory[key].day,
    })
    days.push(transactionHistory[key].day)
  });

  useEffect(() => {
    setSeries(newDataTrans)
    setCategory(days[0])
  }, [transactionHistory,category,setSeries])
  console.log(category);

  const data = {
    chart: {
      height: 550,
      type: 'area',
      toolbar: {
        show: false
      }
    },
    legend: {
      show: false
    },
    stroke: {
      show: true,
      width: 3,
      colors: ['#6418C3', '#F56B3F', '#FFF555', "#777", "#465765", '#555', "#222"]
    },
    colors: ['#6418C3', '#F56B3F', '#FFF555', "#777", "#465765", '#555', "#222"],
    dataLabels: {
      enabled: false
    },
    fill: {
      colors: ['transparent'],
      type: 'solid',
    },
    tooltip: {
      theme: "dark"
    },
    grid: {
      borderColor: "transparent",
      yaxis: {
        lines: {
          show: true
        }
      },
    },
    xaxis: {
      // type: 'category',
      categories: category && category
    },
    yaxis: {
      show: false
    }
  }
  const [options,setOptions] = useState(data);
  useEffect(() => {
    setOptions(data)
  }, [setOptions,category])
  return (
    <div className="cardContainer">
      <Chart
        options={options}
        series={series}
        type="area"
        height={250}
      />
      {
        loading && <Loader />
      }
    </div>
  )
}
export default ChartTransaction
